import React from 'react'
import Container from '@material-ui/core/Container';
import mapa from '../../assets/mapa1.png';
import casazen from '../../assets/casazen.svg';


const Section2 = () => {
  return (
    <div id='ubicacion' className='section noPadBot'>
        <Container className='relative flex flexCenter flexCol'> 
        <img className='logoHero' src={casazen} alt="Logo Casa Zen" />
        <p className='textCenter'>Un proyecto de caracterísicas únicas, cuyo patio central otorga a la vivienda una luminosidad y frescura sin igual, desde donde se generan transparencias que permiten un estecho vinculo con el exterior.</p>               
          <div className="flex flexCol margtop relative mapa">
            <div className="floatTitle shadow">
              <h2>Ubicación</h2>
              <p>Country Costa del Sol, Lote 240<br />
              Mar Chiquita - Buenos Aires
              </p>

            </div>
              <img src={mapa} alt="Mapa"/>

          </div>
        </Container>
    </div>
  )
}

export default Section2